import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { Sidebar } from "../Types/types";
import { RootState } from "../../Core/Store";

const initialState: Sidebar = {
  isOpen: true,
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    toggleSidebar: (state, action: PayloadAction<Sidebar>) => {
      return action.payload;
    },
  },
});

export const { toggleSidebar } = sidebarSlice.actions;

export const getSidebarStatusSelector = (state: RootState) =>
  state.sidebar.isOpen;

export default sidebarSlice.reducer;
